import { makeStyles, tokens } from '@fluentui/react-components';
export var useAppStyles = makeStyles({
    container: {
        display: 'flex',
        flexDirection: 'column',
    },
    content: {
        display: 'flex',
        position: 'absolute',
        left: 0,
        bottom: 0,
        right: 0,
        top: '48px',
        backgroundColor: tokens.colorNeutralBackground2,
    },
    contentShellShyHeaderMode: {
        top: '8px',
    },
});
export var useVisualRefreshStyles = makeStyles({
    content: {
        left: '0px',
        bottom: '0px',
        right: '0px',
        top: '48px',
    },
    appContainer: {
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
    },
    contentContainer: {
        position: 'absolute',
        left: '68px',
        bottom: tokens.spacingVerticalXS,
        right: tokens.spacingVerticalXS,
        top: tokens.spacingVerticalXS,
        backgroundColor: tokens.colorTransparentBackground,
        borderRadius: tokens.borderRadiusXLarge,
        overflow: 'hidden',
        boxShadow: tokens.shadow4,
    },
});
//# sourceMappingURL=App.styles.js.map